import { atom } from 'jotai';

export const isLandingPageAtom = atom(null);
